export const ROUTE_PATHS = Object.freeze({
  HOME: "/",

  // SERVICES
  AI_ML: "/ai-ml",
  COMPUTER_VISION : "/computer-vision",
  GENERATIVE_AI: "/generative-ai",
  AGENTS_AI: "/agents-ai",
  EMBEDDED_IOT: "/embedded-iot",
  DATA_SCIENCE: "/data-science",
  MOBILE_APP_DEV: "/mobile-application-development",
  WEB_DEV: "/web-development",
  ON_DEMAND_DEV: "/on-demand-software-development",


  // ABOUT
  ABOUT_US: "/about-us",
  CULTURE: "/culture",
  VISION_MISSION: "/vision-mission",

  // MAIN
  CAREER: "/career",
  PORTFOLIO: "/portfolio",
  CONTACT_US: "/contact-us",
});
